import { SG_EVENT_NAMES } from '@/utils/tools/segment/eventNames';
import { trackEvent } from '@/utils/tools/segment/tracking';
import axios from 'axios';
import { useEffect } from 'react';
import useSWR from 'swr';

// hook to get current user using SWR
/**
 * @returns {object} user, error, isLoading
 */
// using this arrary as static counter to avoid multiple rendering to not submit event multiple times
const arr = [];

export function useCurrentUser() {
   const fetcher = (url) =>
      fetch(url).then(async (res) => {
         if (!res.ok) {
            const error = new Error();
            error.info = await res.json();
            error.message = error.info.message;
            error.status = res.status;
            throw error;
         }
         return res.json();
      });
   const { data, error, isLoading, mutate } = useSWR('/api/user/current', fetcher);
   const user = data;

   // HERE we will check on the isNewUser Flag in the user
   const updateUser = async function () {
      if (user.isNewUser && arr.length < 1) {
         arr.push('1');
         trackEvent(SG_EVENT_NAMES.USER_SIGN_UP, { email: user?.email, id: user?.id });
         const modifiedUser = await axios.post('/api/change-newUser-flag');
         return;
      }
   };
   useEffect(() => {
      if (user?.isNewUser) {
         updateUser();
         return;
      }
   }, []);

   return { user, error, isLoading, mutate };
}
